import { o } from 'odata';
import { map } from 'lodash';

import { odataConf } from '../odata/conf';

const url = `${process.env.VUE_APP_APIURL}/odata/`;

export default {
  clearReportMetrics: ({ commit }) => {
    commit('reportMetrics', undefined);
  },
  loadAssessmentsWithClients: async ({ commit, rootState }) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get('assessments')
      .query({ $filter: 'IsDeleted eq false', $expand: 'client' });
    commit('assessmentsWithClients', data);
  },
  loadReportMetrics: async ({ commit, rootState }, assessmentId) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get('assessmentItems')
      .query({ $filter: `assessmentId eq ${assessmentId}`, $expand: 'Metric($expand=MetricTab), Assessment' });
    commit('reportMetrics', data);
  },
  loadMultipleReportMetrics: async ({ commit, rootState }, assessmentIds) => {
    const queryItems = map(assessmentIds, assessmentId => `assessmentId eq ${assessmentId}`);
    const filter = queryItems.join(' or ');
    const data = await o(url, odataConf.getConf(rootState))
      .get('assessmentItems')
      .query({ $filter: filter, $expand: 'Metric($expand=MetricTab), Assessment' });
    commit('reportMetrics', data);
  },
  startAssessment: async ({ rootState }, data) => {
    const assessment = await o(url, odataConf.getConf(rootState))
      .post('assessments', data)
      .query();
    return assessment;
  },
  loadAssessment: async ({ commit, rootState }, id) => {
    const i = odataConf.parseId(id);
    const data = await o(url, odataConf.getConf(rootState))
      .get(`assessments(${i})`)
      .query({ $expand: 'AssessmentItems, Client' });
    commit('currentAssessment', data);
  },
  resetCurrentAssessment: ({ commit }) => {
    commit('currentAssessment', undefined);
  },
  getUserAssessment: async ({ commit, rootState }, username) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get('assessments')
      .query({ $filter: `IsDeleted eq false and createdBy eq '${username}'`, $expand: 'client' });
    commit('assessmentsWithClients', data);
  },
};
